import Vue from 'vue'
import Axios from 'axios'
import baseURL from '_conf/url'
import { Message,Modal } from 'iview'
import Cookies from 'js-cookie'
import { TOKEN_KEY } from '@/libs/util'
Vue.prototype.$Modal = Modal
Vue.component('Modal',Modal);
class httpRequest {
  constructor () {
    this.options = {
      method: '',
      url: ''
    }
    // 存储请求队列
    this.queue = {}
  }
  // 销毁请求实例
  destroy (url) {
    delete this.queue[url]
    const queue = Object.keys(this.queue)
    return queue.length
  }
  // 请求拦截
  interceptors (instance, url) {
    // 添加请求拦截器
    instance.interceptors.request.use(config => {
      if (!config.url.includes('/users')) {
        config.headers['x-access-token'] = Cookies.get(TOKEN_KEY)
      }
      // Spin.show()
      // 在发送请求之前做些什么
      return config
    }, error => {
      // 对请求错误做些什么
      return Promise.reject(error)
    })

    // 添加响应拦截器
    instance.interceptors.response.use((res) => {
      let { data } = res
      // console.log(data);
      const is = this.destroy(url)
      if (!is) {
        setTimeout(() => {
          // Spin.hide()
        }, 500)
      }
      if (!(data instanceof Blob)) {
        if(data.status){
          if (data.status !== 200 ) {
            // 后端服务在个别情况下回报201，待确认
            if (data.status === 401) {
              Cookies.remove(TOKEN_KEY)
              Message.error('未登录，或登录失效，请登录');
              setTimeout(()=>{
                window.location.href = '/'
              },800)
            } else if(data.status === 403){ //无权限
              Cookies.remove(TOKEN_KEY);
              Message.error(data.message);
              setTimeout(()=>{
                window.location.href = '/'
              },800)
            } else if(data.status === 998){ //998选择员工组件 重复方案人员 提示。批量审批 提示
              return data
            } else {
              if(window.document.location.pathname == '/login'){
                if (data.message){
                  Modal.error({
                    content: `<p>${data.message}</p>`,
                    onOk: () => {},
                    onCancel: () => {}
                  });
                }
              }else{
                // if (data.message) Message.error(data.message);
                if(data.message){ //如果返回999时，显示弹出框
                  Modal.error({
                    content: `<p>${data.message}</p>`,
                    onOk: () => {},
                    onCancel: () => {}
                  })
                }
                return false
              }
            }
            return false
          }
        }
      }
      return data
    }, (error) => {
      Message.error('服务内部错误')
      // 对响应错误做点什么
      return Promise.reject(error)
    })
  }
  // 创建实例
  create () {
    let conf = {
      baseURL: baseURL,
      // baseURL:'',
      // timeout: 2000,
      headers: {
        'Content-Type': 'application/json',
        'X-URL-PATH': location.pathname
      }
    }
    return Axios.create(conf)
  }
  // 合并请求实例
  mergeReqest (instances = []) {
  //
  }
  // 请求实例
  request (options) {
    var instance = this.create()
    this.interceptors(instance, options.url)
    options = Object.assign({}, options)
    this.queue[options.url] = instance
    return instance(options)
  }
}
export default httpRequest



// WEBPACK FOOTER //
// ./src/libs/axios.js